export default function Home() {
  return (
    // This is the template home page, please edit from this page
    <div className="relative flex flex-col items-center justify-center h-screen text-center px-4">
      <p className="absolute top-4 text-lg text-gray-500">You can switch pages using this dropdown menu ⬆️</p>
      <div className="relative z-10">
        <h1 className="text-xl md:text-2xl font-semibold mt-6">This is homepage, but there is no content yet</h1>
        <p className="mt-4 text-lg md:text-xl text-gray-500">Tell me more about homepage, so I can generate it</p>
      </div>
    </div>
  );
}